"use client";

import {getShelfId} from "../../../../../_components/CourseShelf";
import ScrollingLinkButton from "../../../../../_components/ScrollingLinkButton";
import {ButtonVariant} from "../../../../../_components/Button";
import {CatalogSection} from "../catalogTypes";
import * as _ from "lodash-es";
import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import clsMerge from "@/app/util/clsMerge";

interface CatalogSubjectButtonsProps {
	catalogSections: CatalogSection[];
}

const CatalogSubjectButtons: FCWithHTMLAttributes<
	CatalogSubjectButtonsProps
> = ({catalogSections, className}) => {
	const uniqueSubjects = _.uniqBy(
		catalogSections.map((section) => section.subject.data.attributes),
		"subjectId"
	);
	return (
		<div
			className={clsMerge(
				"flex justify-start gap-2 overflow-x-scroll border-0 px-4 pb-4 md:z-course-filter-header md:overflow-hidden md:rounded-full md:border md:border-gray-400 md:bg-gray-200 md:px-6 md:py-5 md:shadow-lg",
				className
			)}
		>
			{uniqueSubjects.map(({subjectId, subjectName}) => {
				const shelfId = getShelfId(subjectId);
				return (
					<ScrollingLinkButton
						variant={ButtonVariant.FILTER_ROUND}
						key={subjectId}
						href={`#${shelfId}`}
						targetId={shelfId}
					>
						{subjectName}
					</ScrollingLinkButton>
				);
			})}
		</div>
	);
};

export default CatalogSubjectButtons;
